<template>
  <b-container fluid>
    <b-container>
      <div v-if="isLoading" class= "loader-section">
        <frontoffice-loader />
      </div>

      <div v-if="!isLoading && notifs.length" class="notification-list">
        <page-title>
          {{ $t('notification.default') }}
        </page-title>

        <b-row class="justify-content-center">
          <b-col lg="10" xl="8" class="notification-content">
            <message v-for="notif in notifs" :key="notif.id"
                     :date="notif.date" class="message"
            >
              <booking-card v-if="notif.booking" :booking="notif.booking" />

              <div class="notif-link">
                <router-link :to="notif.route" class="btn orange-white">
                  {{ notif.text }}
                </router-link>
              </div>
            </message>
          </b-col>
        </b-row>
      </div>

      <div v-if="!isLoading && notifs.length === 0" class="notfound">
        {{ $t('notification.empty') }}
      </div>
    </b-container>
  </b-container>
</template>

<script>
import CommonApi from '@/api/commonApi'
import pageTitle from '@/components/frontoffice/pageTitle'
import message from '@/components/frontoffice/notification/message'
import frontofficeLoader from '@/components/frontoffice/loader'
import { getStatusTranslation } from '@/utils/bookingStatus'
import bookingCard from '@/components/frontoffice/Booking/card'
import axios from "axios/index";
import commonApi from "@/api/commonApi";

export default {
  components: {
    pageTitle,
    frontofficeLoader,
    message,
    bookingCard
  },

  data () {
    return {
      commonApi: new CommonApi(),
      notifs: [],
      isLoading: true,
      isManager: this.$store.getters['security/hasRole']('ROLE_MANAGER')
    }
  },

  created () {

    this.commonApi.getNotifications()
      .then(response => {
        let bookings = response.data.data.bookings

        for (let booking of bookings) {
          let key = this.isManager ? 'manager' : 'default'

          this.notifs.push({
            booking: booking,
            date: booking.updated_at,
            route: {
              name: 'home_booking_show',
              params: { id : booking.id }
            },
            text: getStatusTranslation(booking.status, this.isManager)
          })
        }

        let survey = response.data.data.survey

        if (survey.available) {
          this.notifs.push({
            date: survey.date,
            route: { name: 'home_survey' },
            text: this.$t('surveyReply.notif')
          })
        }

        let helps = response.data.data.hasOwnProperty('helps') ? response.data.data.helps : null // Récupérer les aides à notifier

        if (helps) {
          helps.forEach(help => {
            let title = help.title
            let dateHelp = help.updated_at ? help.updated_at : help.created_at

            this.notifs.push({
              date: dateHelp,
              help: help,
              route: {
                name: 'home_help_show'
              },
              text: this.$t('Une nouvelle rubrique vient d’être postée/modifiée à l’Aide en ligne ' + title.toUpperCase() + '; N’hésitez pas à venir la découvrir')
            })
          })
        }

        let news = response.data.data.hasOwnProperty('news') ? response.data.data.news : null

        if (news) {
          news.forEach(_new => {
            let name = _new.name
            let dateNew = _new.updated_at ? _new.updated_at : _new.created_at

            this.notifs.push({
              date: dateNew,
              new: _new,
              route: {
                name: 'news'
              },
              text: this.$t('Une nouvelle actualité vient d’être postée, ' + name.toUpperCase() + '. Ne tardez pas à découvrir les nouvelles fonctionnalités de la plateforme.')
            })
          })
        }

        this.notifs.sort((msg1, msg2) => {
          return msg1.date < msg2.date ? -1 : 1;
        })
      }).then(response => {
        this.isLoading = false
      })
  }
}
</script>
